import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";

// Supported languages. Add a new entry here (plus a matching JSON file) to
// extend localization to another language.
export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

const supportedCodes = SUPPORTED_LANGUAGES.map((l) => l.code);

i18n
  // Detection order:
  //   1. URL query string (?language=es)
  //   2. value previously stored in localStorage
  //   3. the browser's configured language(s) (navigator)
  // Whatever is detected is cached back to localStorage so the choice sticks.
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: supportedCodes,
    // Treat "es-MX", "es-ES", etc. as "es" so browser locales map cleanly.
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "language",
      lookupLocalStorage: "language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React already escapes against XSS
    },
    returnNull: false,
  });

export default i18n;
